module.exports = __webpack_public_path__ + "static/media/noticia6.cf1fd142.jpg";